import { render, staticRenderFns } from "./ProfileCluster.vue?vue&type=template&id=989415f0"
import script from "./ProfileCluster.vue?vue&type=script&lang=js"
export * from "./ProfileCluster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports